//값이 있는지 없는지 체크
export const stringHasLength = (value) => {
	// "string", [array], {object} 빈값으로 처리
	if( value === "" || value === null || value === undefined || String(value).trim() === '' || ( value !== null && typeof value === "object" && !Object.keys(value).length ) ){
		return false
	}else{
		return true
	}
}